module.exports = __webpack_public_path__ + "static/Disability-in-the-bush-Yolngu-2020-07-17-09d010f3fed5d489cc5d1bc36edeeaa8.mp3";